import { render } from "./Table.vue?vue&type=template&id=0fcc2863"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=0fcc2863&lang=scss"
script.render = render

export default script